import { useState, useEffect } from 'react'
import {getFieldNameBuilder, weekDaysIndexed, dayDescriptors, monthsIndexed, initDatePatternState} from "../../util";

export const DatePattern = ({ state: [state, setState], periodicity, fieldPrefix }) => {

  const getFieldName = getFieldNameBuilder(fieldPrefix);

  const [ weekDays, setWeekDays ] = useState(weekDaysIndexed )

  if(!state) {
    const [state, setState] = initDatePatternState();
  }

  const monthField = tangibleFields.render({
    type: 'select',
    name: getFieldName('month'),
    choices: monthsIndexed,
    value: state.month.toString()
  })

  const dayDescriptorField = tangibleFields.render({
    type: 'select',
    name: getFieldName('day_descriptor'),
    choices: dayDescriptors,
    value: state.dayDescriptor.toString(),
  })

  const dayOfWeekField = tangibleFields.render({
    type: 'select',
    name: getFieldName('day_number'),
    choices: weekDays,
    value: state.dayOfWeek.toString(),
  })

  const dayOfMonthField = tangibleFields.render({
    type: 'number',
    name: getFieldName('day_of_month'),
    minValue: 1,
    maxValue: 31,
    value: state.dayOfMonth.toString()
  })

  tangibleFields.event('valueChange', field => {

    if ( field.name === getFieldName('month') ) {
      setState({...state, month: field.value})
    } else if ( field.name === getFieldName('day_descriptor') ) {
      setState({...state, dayDescriptor: field.value})
    } else if ( field.name === getFieldName('day_number') ) {
      setState({...state, dayOfWeek: field.value})
    } else if ( field.name === getFieldName('day_of_month') ) {
      setState({...state, dayOfMonth: field.value})
    }

  })

  // Using a ternary, i.e. condition? oneField: theOtherField leads to weirdness
  let showMonth = (state.dayDescriptor === 'dayofmonth' && periodicity.period !== 'weekly');
  let showWeek = !showMonth;

  return (
    <>
      <div className="row">
      { periodicity.period === 'yearly' &&
        <>
          <span className="tf-description">In</span>
          { monthField }
        </>
      }
      </div>

      <div className="row">
        { periodicity.period !== 'weekly' && (
          <>
            <span className="tf-description">On the</span>
            {dayDescriptorField}
          </>
        )}
        { showMonth && dayOfMonthField }
        { showWeek && dayOfWeekField }
      </div>
    </>
  )
}
